import { render } from "./FacilityFlange.vue?vue&type=template&id=81261f68"
import script from "./FacilityFlange.vue?vue&type=script&setup=true&lang=js"
export * from "./FacilityFlange.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/facility/FacilityFlange.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "81261f68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('81261f68', __exports__)) {
    console.log('reload')
    api.reload('81261f68', __exports__)
  }
  
  module.hot.accept("./FacilityFlange.vue?vue&type=template&id=81261f68", () => {
    console.log('re-render')
    api.rerender('81261f68', render)
  })

}


export default __exports__